import React, { useEffect, useRef } from 'react'

import TextInput from '../../TextInput/TextInput'
import RenderDateField from './RenderDateField'
import RenderFileSizeField from './RenderFileSizeField'
import SuggestQuery from './SuggestQuery'
import Icon from '../../Icon2/Icon'

import { updateCurrentQuery, getTypeOfValueByQueryType } from '../util/helper'


const getNotRegexValue = (isNotOperator, Value) => {
  let validValue = Value
  if (isNotOperator && Value && typeof Value['$regex'] !== "undefined") {
    validValue = Value['$regex']
  } else if (isNotOperator && Value && typeof Value['$regex'] === "undefined") {
    validValue = Value
  } else if (!isNotOperator && Value && typeof Value['$regex'] !== "undefined") {
    validValue = Value['$regex']
  } else if (!isNotOperator && Value && typeof Value['$regex'] === "undefined") {
    validValue = Value
  }
  return validValue
}

const InputSuffix = ({ handleSearchClear }) => {
  return (
    <Icon
      version="v2"
      icon="Cancel"
      size="small"
      className="SearchBar__input--cancel"
      onClick={handleSearchClear}
      testId="cs-search-bar-cancel"
    />
  )
}


const RenderValueField = (props) => {
  const { t = (key: string) => '' } = props
  const { key = [], operator = [], value = [], queryType } = props.query
  const valueType = getTypeOfValueByQueryType(queryType)
  const isNotOperator = operator[0]?.value === "$not" ? true : false
  const controlledValue = getNotRegexValue(isNotOperator, value[0]?.label) || (t('AdvanceSearchV2.RenderValueField.select_value') || 'Select value')

  const inputRef = useRef(null)

  const handleInputChange = (e) => {
    const value = e.target.value


    let updatedValue = isNotOperator ? { '$regex': value } : valueType === 'number' ? parseInt(value) : value
    let data = {
      queryType,
      selectedOpt: { label: updatedValue, value: updatedValue },
      type: 'value',
      currentQuery: props.query
    }
    let updatedCurrentQuery = updateCurrentQuery(data)

    props.updateAdvancedQueryArray({
      currentQuery: updatedCurrentQuery,
      queryArray: props.queryArray,
      currentQueryIndex: props.queryIndex,
      action: 'updateQueryArray',
      queryObject: props.queryObj,
      parentQueryObject: props.parentQueryObject
    })
  }


  const fieldCursor = {
    key: 0,
    operator: 1,
    value: 2
  }

  const isCurrentQueryActive = props.cursorY === props.query.queryCursorY
  const isValueActive = isCurrentQueryActive && fieldCursor.value === props.cursorX && !props.isDropdownOpen

  const handleKeyBindings = (e) => {
    const { key } = e
    if (!props.isVisible) return

    if (key === 'Enter' && isValueActive) {
      inputRef.current.focus()
    }
    if (key === 'Escape' && isValueActive) {
      inputRef.current.blur()
    }
  }

  useEffect(() => {
    if (valueType === 'text' || valueType === 'number') {
      document.addEventListener('keyup', handleKeyBindings, false)

      return () => {
        document.removeEventListener('keyup', handleKeyBindings, false)
      }
    }
  }, [isValueActive, props.isVisible])


  if (valueType === 'text' || valueType === 'number') {


    const controlledValue = getNotRegexValue(isNotOperator, value[0]?.label)
    return (
      // todo fix it 2px border -> 1px
      <div className="query-value-textInput" style={{ border: isValueActive ? '2px dashed #6c5ce7' : '' }}>
        <TextInput
          key={`${key[0]?.label}-${queryType}`}
          type={valueType}
          placeholder={t('AdvanceSearchV2.RenderValueField.enter_value') || "Enter value"}
          version="v2"
          width="full"
          value={controlledValue}
          onChange={handleInputChange}
          error={props.query.valueError}
          suffix={
            value[0]?.label && <InputSuffix handleSearchClear={() => handleInputChange({ target: { value: '' } })} />
          }
          inputRef={inputRef}
        />
      </div>
    )
  }

  if (valueType === 'date') {
    return (
      <RenderDateField type="value" placeholderClass={!value[0]?.label ? 'query-value-placeholder' : ''} {...props} isValueActive={isValueActive} t={t} />
    )
  }

  if (queryType === 'fileSizeLabel') {
    return (
      <RenderFileSizeField
        type="value"
        placeholderClass={!value[0]?.label ? 'query-value-placeholder' : ''}
        {...props}
        isValueActive={isValueActive}
        t={t}
      />
    )
  }

  return (
    <SuggestQuery
      testId="cs-advance-search-select-value"
      type="value"
      value={controlledValue}
      placeholderClass={!value[0]?.label ? 'query-value-placeholder' : ''}
      {...props}
      t={t}
    />
  )
}

export default RenderValueField
